import { render, staticRenderFns } from "./CopiedModal.vue?vue&type=template&id=5398a5f5&"
import script from "./CopiedModal.vue?vue&type=script&lang=js&"
export * from "./CopiedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports